import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LegalServiceAccessCheckResponseModal,
  LegalServiceApproveDeclineModal,
  LegalServiceRequestForMissingInfoModel,
  LegalServiceSignUpModal,
  LegalServiceUploadModal,
  LegalServiceDashboardModal,
  ProposalListQueryParams,
  LegalServiceProposalModal,
  LegalServiceStatusModal,
  ProposalPartnerTitleModal,
  ProposalPartnerExperienceModal,
  ProposalPartnerRoleModal,
  LegalServiceNonAccreditedSignUpModal,
  ProposalListAPIQueryParams,
  ProposalUploadModal,
  LegalServiceProposalDetail,
} from "src/models/LegalServiceModal";
import {
  AddUserDetails,
  Status,
  FileData,
  CuStatus,
  ChartData,
  EditVendorModel,
} from "src/models/form_post";
import { apiDelete, apiGet, apiPost, apiPut } from "src/utils/axios";
import { errorHandler } from "src/utils/errorHandler";
import {
  getLsSignUpDetails,
  PostVendorInviteAccessCheck,
  PostVendorSignUp,
  PostVendorUpload,
  analyticsURL,
  getProposalList,
  getProposalDetailList,
  getAllProposalDetails,
  putProposalDetails,
  getProposalStatus,
  PostVendorNonAccreditedSignUp,
  getTcsCorporateAddMemberDropUserGroupUrl,
  getURLForEnum,
  templateBankUrl,
  getVendorTemplateUrl,
  getVendorMasterTemplateUrl,
  postTcsVendor,
  getUserDetailUrl,
  putVendorMasterTemplateUrl,
  postVendorMasterTemplateUrl,
} from "src/utils/pathConst";
import { CorporaterTableInfo, CRQueryParams } from "src/models/select";
import {
  FavouriteListModel,
  RfpParams,
  TemplateListModel,
} from "src/models/rfp";
import { MasterProposalTemplate } from "src/models/ProposalModel";

// TODO: need to update seprate file
export type ErrorInformation = {
  message: string;
  status: number;
};

export interface SubValue {
  id: number;
  label: string;
  name: string;
  isChecked: boolean;
}

type LegalServiceState = {
  loading: boolean;
  error: ErrorInformation;
  getLSChartData: ChartData;
  getlSproviderReviewData: any;
  legalServiceAccessCheckResponse: LegalServiceAccessCheckResponseModal;
  lspUserGroupState: any;
  getDynamicData: any;
  getSpecificCorporateList: any;
  legalServiceSignUpData: LegalServiceSignUpModal;
  legalServiceInviteFormData: object;
  legalServiceOrgIndustriesFormData: any;
  legalServiceOrgPracticesFormData: object;
  legalServiceOrgJurisdictionsFormData: object;
  legalServiceOrgPricingFormData: object;
  legalServiceOrgFileFormData: object;
  legalServiceOrgFileCommentFormData: object;
  legalServiceApprovalDeclineResponse: LegalServiceApproveDeclineModal;
  LegalServiceRequestForMissingInfoResponse: LegalServiceRequestForMissingInfoModel;
  subOptions: null | SubValue[];
  user_details: AddUserDetails;
  getUserValues: Status;
  RFPProposalDetail: LegalServiceProposalModal;
  legalServiceProposalDetail: LegalServiceProposalDetail;
  legalServiceProposalDetailReUse: LegalServiceProposalDetail;
  expectedFeesDetails: LegalServiceStatusModal;
  Proposal: any;
  UpdateIndustryDetails: any;
  UpdateJurisdictionDetails: any;
  ProposalStatusDetails: LegalServiceStatusModal;
  params: CRQueryParams;
  corporaterTableInfo: CorporaterTableInfo;
  proposalPartnerTitleModal: ProposalPartnerTitleModal;
  proposalPartnerExperienceModal: ProposalPartnerExperienceModal;
  proposalPartnerRoleModal: ProposalPartnerRoleModal;
  getEmailValue: Status;
  getFileValues: FileData;
  paymentInfo: any;
  paymentSelection: any;
  StatusDetail: Status;
  getLSScoreCardData: Status;
  getLSKeyTeamData: Status;
  getTeamMemberData: CuStatus;
  getSpecificTeamMemberData: CuStatus;
  deleteTemplate: any;
  templateResponseMessage: any;
  proposalDetailIds: any;
  masterTemplateBankData:any;
};

const initialState: LegalServiceState = {
  loading: true,
  error: null,
  templateResponseMessage: null,
  params: null,
  getLSChartData: null,
  UpdateIndustryDetails: null,
  UpdateJurisdictionDetails: null,
  getlSproviderReviewData: null,
  StatusDetail: null,
  corporaterTableInfo: null,
  deleteTemplate: null,
  getTeamMemberData: null,
  getSpecificTeamMemberData: null,
  legalServiceAccessCheckResponse: null,
  lspUserGroupState: null,
  getDynamicData: null,
  getSpecificCorporateList: null,
  legalServiceSignUpData: null,
  legalServiceApprovalDeclineResponse: null,
  LegalServiceRequestForMissingInfoResponse: null,
  masterTemplateBankData:null,
  legalServiceInviteFormData: {
    invite_email: "",
    ls_provider_name: "",
    companyAddress: "",
    contact: "",
    companyPersonEmail: "",
    companyLocation: "",
    firstname: "",
    lastname: "",
    zip: "",
    city: "",
    country: "",
    communication_email: "",
    cc_email: [""],
    file: "",
  },
  proposalDetailIds: null,
  legalServiceOrgIndustriesFormData: {
    initialValue: [
      {
        label: "All",
        name: "all",
        checked: false,
      },
      {
        label: "Agriculture",
        name: "agriculture",
        checked: false,
      },
      {
        label: "Consumer",
        name: "consumer",
        checked: false,
      },
      {
        label: "Energy & Resources",
        name: "energy_resources",
        checked: false,
      },
      {
        label: "Financial Services",
        name: "financial_services",
        checked: false,
      },
      {
        label: "Government",
        name: "government",
        checked: false,
      },
      {
        label: "Industrials",
        name: "industrials",
        checked: false,
      },
      {
        label: "Life Sciences & Healthcare",
        name: "life_sciences_healthcare",
        checked: false,
      },
      {
        label: "Real Estate",
        name: "real_estate",
        checked: false,
      },
      {
        label: "TMT",
        name: "tmt",
        checked: false,
      },
      {
        label: "Transportation & Logistics",
        name: "transportation_logistics",
        checked: false,
      },
      {
        label: "Other",
        name: "other",
        checked: false,
        subOptions: [
          {
            label: "Comments",
            name: "comment",
            value: "",
          },
        ],
      },
    ],
    comment: "",
  },
  legalServiceOrgPracticesFormData: {
    initialValue: [
      {
        label: "All",
        name: "all",
        checked: false,
      },
      {
        label: "Commercial contracts",
        name: "commercial_contracts",
        checked: false,
      },
      {
        label: "Competition",
        name: "competition",
        checked: false,
      },
      {
        label: "Corporate M&A",
        name: "corporate_ma",
        checked: false,
      },
      {
        label: "Data protection & privacy",
        name: "data_protection_privacy",
        checked: false,
      },
      {
        label: "Employment",
        name: "employment",
        checked: false,
      },
      {
        label: "Financing & capital markets",
        name: "financing_capital_markets",
        checked: false,
      },
      {
        label: "(Infrastructure) project & financing",
        name: "projects_financing",
        checked: false,
      },
      {
        label: "IP",
        name: "ip",
        checked: false,
      },
      {
        label: "IT",
        name: "it",
        checked: false,
      },
      {
        label: "Funds formation",
        name: "funds_formation",
        checked: false,
      },
      {
        label: "Funds Investment",
        name: "funds_investment",
        checked: false,
      },
      {
        label: "Litigation",
        name: "litigation",
        checked: false,
      },
      {
        label: "Arbitration",
        name: "arbitration",
        checked: false,
      },
      {
        label: "Restructuring",
        name: "restructuring",
        checked: false,
      },
      {
        label: "Insolvency",
        name: "insolvency",
        checked: false,
      },
      {
        label: " Regulatory",
        name: "regulatory",
        checked: false,
        subOptions: [
          {
            label: "All",
            name: "all",
            checked: false,
          },
          {
            label: "Finance Services",
            name: "financial_services",
            checked: false,
          },
          {
            label: "Medical Services",
            name: "medical_services",
            checked: false,
          },
          {
            label: "Energy",
            name: "energy",
            checked: false,
          },
          {
            label: "Water",
            name: "water",
            checked: false,
          },
          {
            label: "Telecommunications",
            name: "telecommunications",
            checked: false,
          },
          {
            label: "Transport",
            name: "transport",
            checked: false,
          },
          {
            label: "Media",
            name: "media",
            checked: false,
          },
          {
            label: "Defence",
            name: "defence",
            checked: false,
          },
          {
            label: "Food/Agriculture",
            name: "food_agriculture",
            checked: false,
          },
          {
            label: "Other",
            name: "other",
            checked: false,
            other: {
              value: false,
              comment: "",
            },
          },
        ],
      },
      {
        label: " Tax",
        name: "tax",
        checked: false,
        subOptions: [
          {
            label: "All",
            name: "all",
            checked: false,
          },
          {
            label: "Transactional tax",
            name: "transactional_tax",
            checked: false,
          },
          {
            label: "Tax investigation & dispute",
            name: "tax_investigation_dispute",
            checked: false,
          },
          {
            label: "Transfer pricing",
            name: "transfer_pricing",
            checked: false,
          },
          {
            label: "Indirect tax",
            name: "indirect_tax",
            checked: false,
          },
          {
            label: "Tax planning",
            name: "tax_planning",
            checked: false,
          },
          {
            label: "Tax policy",
            name: "tax_policy",
            checked: false,
          },
          {
            label: "Other",
            name: "other",
            checked: false,
            other: {
              value: false,
              comment: "",
            },
          },
        ],
      },
      {
        label: "Other",
        name: "other",
        checked: false,
      },
    ],
    otherComment: "",
    comment: "",
  },
  legalServiceOrgJurisdictionsFormData: {
    country: [],
    comment: "",
  },
  legalServiceOrgPricingFormData: {
    initialValue: [
      {
        label: "All",
        name: "all",
        checked: false,
      },
      {
        label: "Estimate",
        name: "estimate",
        checked: false,
      },
      {
        label: "Fixed fee",
        name: "fixed_fee",
        checked: false,
      },
      {
        label: "Capped fee",
        name: "capped_fee",
        checked: false,
      },
      {
        label: "Hourly rate fee",
        name: "hourly_rate_fee",
        checked: false,
      },
      {
        label: "Blended rate",
        name: "blended_rate",
        checked: false,
      },
      {
        label: "Contingent fee",
        name: "contingent_fee",
        checked: false,
      },
      {
        label: "Abort discount",
        name: "abort_discount",
        checked: false,
      },
      {
        label: "Success Fee",
        name: "success_fee",
        checked: false,
      },
      {
        label:
          "Reverse Auction (To be conducted by Corporate outside of Temasek)",
        name: "reverse_auction",
        checked: false,
      },
      {
        label: "Free advice up to a certain amount",
        name: "free_advice_amount",
        checked: false,
      },
      {
        label: "Retainer (general/project based)",
        name: "retainer_general_project",
        checked: false,
      },
      {
        label: "Budget for project",
        name: "budget_for_project",
        checked: false,
      },
      {
        label: "Other",
        name: "other",
        checked: false,
      },
    ],
    otherComment: "",
    comment: "",
  },
  legalServiceOrgFileFormData: {
    itSecurityPackage: [],
    dataProtectionPolicy: [],
    latestCsrReport: [],
    professionalIndemnityInsurance: [],
    diversityPolicy: [],
    conflictCheckPolicy: [],
    esgPolicy: [],
    businessEngagementTc: [],
  },
  legalServiceOrgFileCommentFormData: {
    it_security_package: "",
    data_protection_policy: "",
    latest_csr_report: "",
    professional_indemnity_insurance: "",
    diversity_policy: "",
    conflict_check_policy: "",
    report_to_third_party: {
      value: false,
      comment: "",
    },
    external_validation: {
      value: false,
      comment: "test comment",
    },
  },
  subOptions: [],
  user_details: null,
  getUserValues: null,
  RFPProposalDetail: null,
  legalServiceProposalDetail: null,
  legalServiceProposalDetailReUse:null,
  expectedFeesDetails: null,
  Proposal: null,
  ProposalStatusDetails: null,
  proposalPartnerTitleModal: null,
  proposalPartnerExperienceModal: null,
  proposalPartnerRoleModal: null,
  getEmailValue: null,
  getFileValues: null,
  paymentInfo: null,
  paymentSelection: null,
  getLSScoreCardData: null,
  getLSKeyTeamData: null,
};

export const PostVendorAccessCheck = createAsyncThunk<
  LegalServiceAccessCheckResponseModal,
  { legalServiceAccessCheckParam },
  {
    rejectValue: ErrorInformation;
  }
>(
  "LegalServiceConnect/PostVendorAccessCheck",
  async ({ legalServiceAccessCheckParam }, { rejectWithValue }) => {
    try {
      const response = await apiPost(
        `${PostVendorInviteAccessCheck}`,
        legalServiceAccessCheckParam
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getLsSignUpDetail = createAsyncThunk<
  LegalServiceSignUpModal,
  { id },
  {
    rejectValue: ErrorInformation;
  }
>(
  "LegalServiceConnect/getLsSignUpDetail",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${getLsSignUpDetails}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const PostVendorFileUpload = createAsyncThunk<
  LegalServiceUploadModal,
  { file },
  {
    rejectValue: ErrorInformation;
  }
>(
  "LegalServiceConnect/PostVendorFileUpload",
  async ({ file }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${PostVendorUpload}`, file);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const PostVendorSignUpCall = createAsyncThunk<
  LegalServiceSignUpModal,
  { formValue },
  {
    rejectValue: ErrorInformation;
  }
>(
  "LegalServiceConnect/PostVendorSignUp",
  async ({ formValue }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${PostVendorSignUp}`, formValue);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const PostVendorNonAccreditedSignUpCall = createAsyncThunk<
  LegalServiceNonAccreditedSignUpModal,
  { formValue },
  {
    rejectValue: ErrorInformation;
  }
>(
  "LegalServiceConnect/PostVendorNonAccreditedSignUp",
  async ({ formValue }, { rejectWithValue }) => {
    try {
      const response = await apiPost(
        `${PostVendorNonAccreditedSignUp}`,
        formValue
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const fetchScoreCardByVendorId = createAsyncThunk<
{},
 any,
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/fetchScoreCardByVendorId",
  async ({},{ rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${analyticsURL}/vendor_score_card`
      );
      return getResponse.data?.details;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const fetchFilteredInvitationOutcomes = createAsyncThunk<
  {},
  any,
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/fetchFilteredInvitationOutcomes",
  async (params: any, { rejectWithValue }) => {
    const urlParams = new URLSearchParams();
    if (params?.from_date) urlParams.append('from_date', params.from_date);
    if (params?.to_date) urlParams.append('to_date', params.to_date);
    try {
      const getResponse = await apiGet(`${analyticsURL}/vendor_invitation_outcomes?${urlParams.toString()}`);
      return getResponse.data.details;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getProposalDetails = createAsyncThunk<
  LegalServiceDashboardModal,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getProposalList",
  async (params: ProposalListQueryParams, { rejectWithValue }) => {
    try {
      const getProposalResponse = await apiGet(
        `${getProposalList}/list?sortBy=${params.sortBy}&sortDir=${params.sortDir}&limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&isDashboard=${params.is_dashboard}`
      );
      return getProposalResponse.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getCompletedProposalList = createAsyncThunk<
  LegalServiceDashboardModal,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getProposalList",
  async (params: ProposalListQueryParams, { rejectWithValue }) => {
    try {
      const getProposalResponse = await apiGet(
        `${getProposalList}/completed_proposal`
      );
      return getProposalResponse.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getProposalListView = createAsyncThunk<
  LegalServiceDashboardModal,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getProposalList",
  async (params: ProposalListAPIQueryParams, { rejectWithValue }) => {
    try {
      const getProposalResponse = await apiGet(
        `${getProposalList}/list?sortBy=${params.sortBy}&sortDir=${params.sortDir}&limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&status=${params.status}`
      );
      return getProposalResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);


export const getProposalAccessRuleStatus = createAsyncThunk<
  any,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/getProposalAccessRuleStatus", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "ProposalRestrictedStatus");
    return getResponse.data.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});


export const getRFPProposalDetail = createAsyncThunk<
  LegalServiceProposalModal,
  { queryParam },
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getProposalDetailList",
  async ({ queryParam }, { rejectWithValue }) => {
    try {
      // const getTeamResponse = await apiGet(`${getProposalDetailList}/${corporateId}/${rfpId}/${Id}`);
      const getTeamResponse = await apiGet(
        `${getProposalDetailList}/${queryParam.corporate_id}/${queryParam.rfp_id}`
      );
      return getTeamResponse.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getAllProposalValue = createAsyncThunk<
  LegalServiceProposalModal,
  { queryParam },
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getAllProposalDetails",
  async ({ queryParam }, { rejectWithValue }) => {
    try {
      // const getTeamResponse = await apiGet(`${getProposalDetailList}/${corporateId}/${rfpId}/${Id}`);
      const getProposalResponse = await apiGet(
        `${getAllProposalDetails}/${queryParam.proposal_id}`
      );
      const response = getProposalResponse.data?.detail;
      if (response?.scope_of_work?.requirement) {
        response.scope_of_work.requirement.forEach((req) => {
          if (req.price === null) {
            req.price = "";
          }
          if (req.unit_price === null) {
            req.unit_price = "";
          }
          // if (req.type_of_rate_card === null) {
          //   req.type_of_rate_card = "";
          // }
        });
      }
      return response;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getPastProposalDetails = createAsyncThunk<
  LegalServiceProposalModal,
  { queryParam },
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getPastProposalDetails",
  async ({ queryParam }, { rejectWithValue }) => {
    try {
      // const getTeamResponse = await apiGet(`${getProposalDetailList}/${corporateId}/${rfpId}/${Id}`);
      const getProposalResponse = await apiGet(
        `${getAllProposalDetails}/${queryParam.proposal_id}`
      );
      const response = getProposalResponse.data?.detail;
      if (response?.scope_of_work?.requirement) {
        response.scope_of_work.requirement.forEach((req) => {
          if (req.price === null) {
            req.price = "";
          }
          if (req.unit_price === null) {
            req.unit_price = "";
          }
          // if (req.type_of_rate_card === null) {
          //   req.type_of_rate_card = "";
          // }
        });
      }
      return response;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getDiscloseBidders = createAsyncThunk<
  any,
  any,
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getDiscloseBidders",
  async (queryParam, { rejectWithValue }) => {
    try {
      const response = await apiGet(
        `${getProposalList}/get_disclose_bidder/${queryParam.rfp_id}`
      );
      console.log(response,"getProposalResponse");
      return response.data
    } catch (error) {
      console.log(error,"error");
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const ProposalStatus = createAsyncThunk<
  LegalServiceStatusModal,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/getProposalStatus", async ({}, { rejectWithValue }) => {
  try {
    const ProposalDetails = await apiGet(`${getProposalStatus}`);
    return ProposalDetails.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const putConflictCheck = createAsyncThunk<
  LegalServiceProposalModal,
  { queryParam; Proposal },
  {
    rejectValue: ErrorInformation;
  }
>(
  "post/putProposalDetails",
  async ({ queryParam, Proposal }, { rejectWithValue }) => {
    try {
      const response = await apiPut(
        `${putProposalDetails}/${queryParam.legal_service_id}/${queryParam.proposal_id}`,
        Proposal
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);
// Vendor UserGroup dropdown Api
export const getTcsCorporateAddMemberDropUserGroup = createAsyncThunk<
  FavouriteListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "TcsConnect/getTcsCorporateAddMemberDropUserGroup",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getTcsCorporateAddMemberDropUserGroupUrl}?sortBy=${params.sortBy}&sortDir=${params.sortDir}&limit=${params.limit}&offset=${params.offset}&status=${params.status}&searchString=${params.search_string}`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getProposalListStatus = createAsyncThunk<
  ProposalUploadModal,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/ProposalStatus", async ({}, { rejectWithValue }) => {
  try {
    const getResponse = await apiGet(getURLForEnum + "ProposalStatus");
    return getResponse.data?.details;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

// Get Template Bank
export const getVendorTemplateList = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getVendorTemplateList",
  async (params: ProposalListQueryParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getVendorTemplateUrl}/list?limit=${params.limit}&offset=${
          params.offset
        }&sortDir=${params.sortDir}&sortBy=${params.sortBy}${
          params.search_string !== ""
            ? "&searchString=" + params.search_string
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const putProposalAssign = createAsyncThunk<
  any,
  { payload: any; },
  { rejectValue: ErrorInformation }
>(
  "proposal/putProposalAssign",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`${getProposalList}/assign`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const putExportProposal = createAsyncThunk<
  any,
  any,
  { rejectValue: ErrorInformation }
>(
  "proposal/putExportProposal",
  async ({ proposal_id }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`${getProposalList}/export_proposal/${proposal_id}`,{});
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const putProposalTemplate = createAsyncThunk<
  string, //output
  { payload: MasterProposalTemplate; params: any },
  { rejectValue: ErrorInformation }
>(
  "proposal/putProposalTemplate",
  async ({ payload, params }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`${getVendorTemplateUrl}/${params}`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

// DELETE VENDOR TEMPLATE BANK

export const deleteVendorTemplateBank = createAsyncThunk<
  any,
  { params: any },
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/DeleteVendorTemplateBank",
  async ({ params }, { rejectWithValue }) => {
    try {
      const response = await apiDelete(
        `${getVendorTemplateUrl}/${params}`,
        params
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const createVendorTemplateList = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/createVendorTemplateList", async (payload, { rejectWithValue }) => {
  try {
    const getResponse = await apiPost(`${getVendorTemplateUrl}`, payload);
    return getResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

// GET Master Template Bank

export const getMasterTemplatesBankDetails = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getVendorTemplateList",
  async (params: ProposalListQueryParams, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getVendorMasterTemplateUrl}/list/${params.vendor_id}?limit=${
          params.limit
        }&offset=${params.offset}&sortDir=${params.sortDir}&sortBy=${
          params.sortBy
        }${
          params.search_string !== ""
            ? "&searchString=" + params.search_string
            : ""
        }`
      );
      return getResponse.data.detail[0];
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);


//Master Template 
export const getMasterTemplateBankDetail = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getVendorTemplateList",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getVendorMasterTemplateUrl}/get_detail/${params.id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const putMasterTemplateData = createAsyncThunk<
  string, //output
  { payload: MasterProposalTemplate; params: any },
  { rejectValue: ErrorInformation }
>(
  "proposal/putMasterTemplateData",
  async ({ payload, params }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`${putVendorMasterTemplateUrl}/${params}`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const postMasterTemplateData = createAsyncThunk<
  string, //output
  { payload: MasterProposalTemplate },
  { rejectValue: ErrorInformation }
>(
  "proposal/postMasterTemplateData",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${postVendorMasterTemplateUrl}`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);


export const getProposalTemplateDetail = createAsyncThunk<
  TemplateListModel,
  {},
  {
    rejectValue: ErrorInformation;
  }
>(
  "select/getVendorTemplateList",
  async (params: any, { rejectWithValue }) => {
    try {
      const getResponse = await apiGet(
        `${getVendorTemplateUrl}/get_detail/${params.id}`
      );
      return getResponse.data.detail;
    } catch (error) {
      return rejectWithValue(errorHandler(error));
    }
  }
);

export const getVendorUserList = createAsyncThunk<
  Status,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/getVendorUserList", async (params: any, { rejectWithValue }) => {
  try {
    const getTeamResponse = await apiGet(
      `${getUserDetailUrl}/by-vendor-id/${params.vendor_id}?limit=${params.limit}&offset=${params.offset}&searchString=${params.search_string}&sortDir=${params.sortDir}&sortBy=${params.sortBy}`
    );
    return getTeamResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});

export const deleteVendorUser = createAsyncThunk<
  Status,
  {},
  {
    rejectValue: ErrorInformation;
  }
>("select/deleteVendorUser", async (bodyParams: any, { rejectWithValue }) => {
  try {
    const getTeamResponse = await apiDelete(
      `${getUserDetailUrl}/${bodyParams._id}`,bodyParams
    );
    return getTeamResponse.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});


export const UpdateTcsVendor = createAsyncThunk<
  EditVendorModel,
  { bodyParams: any },
  {
    rejectValue: ErrorInformation;
  }
>("TcsConnect/PostTcsCorpUser", async ({ bodyParams }, { rejectWithValue }) => {
  try {
    const response = await apiPut(`${postTcsVendor}/`, bodyParams);
    return response.data;
  } catch (error) {
    return rejectWithValue(errorHandler(error));
  }
});
export const legalServiceSlice = createSlice({
  name: "LegalServiceConnect",
  initialState,
  reducers: {
    updateLearningForm: (state, action: PayloadAction<any>) => {
      state.legalServiceInviteFormData = action.payload;
    },
    updateOrgIndustriesForm: (state, action: PayloadAction<any>) => {
      state.legalServiceOrgIndustriesFormData = action.payload;
    },
    updateOrgPracticesForm: (state, action: PayloadAction<any>) => {
      state.legalServiceOrgPracticesFormData = action.payload;
    },
    updateOrgJurisdictionForm: (state, action: PayloadAction<any>) => {
      state.legalServiceOrgJurisdictionsFormData = action.payload;
    },
    updateOrgPricingForm: (state, action: PayloadAction<any>) => {
      state.legalServiceOrgPricingFormData = action.payload;
    },
    updateOrgFileForm: (state, action: PayloadAction<any>) => {
      state.legalServiceOrgFileFormData = action.payload;
    },
    updateOrgFileCommentForm: (state, action: PayloadAction<any>) => {
      state.legalServiceOrgFileCommentFormData = action.payload;
    },
    handleResetLegalServiceProposalDetail: (state) => {
      state.legalServiceProposalDetail = null;
    },

    handleResetMasterTemplate: (state) => {
      state.masterTemplateBankData = null;
    },

    // setProposalDataByTemplate: (state, action) => {
    //   state.legalServiceProposalDetail = action?.payload;
    // },

    setProposalDataByTemplate: (state, action) => {
      const previousProposalDetail = state.legalServiceProposalDetail;
          if (action?.payload?.scope_of_work?.requirement) {
        action.payload.scope_of_work.requirement = action.payload?.scope_of_work?.requirement?.map((req, index) => {
          const requirement_id = previousProposalDetail?.scope_of_work?.requirement?.[index]?.requirement_id || '';
          return {
            ...req,
            requirement_id: req.requirement_id || requirement_id
          };
        });
      }
    
      // Set the updated proposal data in state
      state.legalServiceProposalDetail = action?.payload;
    },

    

    proposalDetailIdsStore: (state, action) => {
      state.proposalDetailIds = action?.payload;
    },
    proposalDetailIdsRemove: (state) => {
      state.proposalDetailIds = null;
    },
  },
  extraReducers: {
    //ls signup access check
    [PostVendorAccessCheck.pending.type]: (state) => {
      state.loading = true;
    },
    [PostVendorAccessCheck.fulfilled.type]: (
      state,
      action: PayloadAction<LegalServiceAccessCheckResponseModal | null>
    ) => {
      state.legalServiceAccessCheckResponse = action.payload;
      state.loading = false;
    },
    [PostVendorAccessCheck.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getLsSignUpDetail.pending.type]: (state) => {
      state.loading = true;
    },
    [getLsSignUpDetail.fulfilled.type]: (
      state,
      action: PayloadAction<LegalServiceSignUpModal | null>
    ) => {
      state.legalServiceSignUpData = action.payload;
      state.loading = false;
    },
    [getLsSignUpDetail.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getRFPProposalDetail.pending.type]: (state) => {
      state.loading = true;
    },
    [getRFPProposalDetail.fulfilled.type]: (
      state,
      action: PayloadAction<LegalServiceProposalModal | null>
    ) => {
      state.RFPProposalDetail = action.payload;
      state.loading = false;
    },
    [getRFPProposalDetail.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getAllProposalValue.pending.type]: (state) => {
      state.loading = true;
    },
    [getAllProposalValue.fulfilled.type]: (
      state,
      action: PayloadAction<LegalServiceProposalDetail | null>
    ) => {
      state.legalServiceProposalDetail = action.payload;
      state.legalServiceProposalDetailReUse = action.payload
      state.loading = false;
    },
    [getAllProposalValue.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getMasterTemplateBankDetail.pending.type]: (state) => {
      state.loading = true;
    },
    [getMasterTemplateBankDetail.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.masterTemplateBankData = action.payload;
      state.loading = false;
    },
    [getMasterTemplateBankDetail.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },


    [putConflictCheck.pending.type]: (state) => {
      state.loading = true;
    },
    [putConflictCheck.fulfilled.type]: (
      state,
      action: PayloadAction<any | null>
    ) => {
      state.Proposal = action.payload;
      state.loading = false;
    },
    [putConflictCheck.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [ProposalStatus.pending.type]: (state) => {
      state.loading = true;
    },
    [ProposalStatus.fulfilled.type]: (
      state,
      action: PayloadAction<LegalServiceStatusModal | null>
    ) => {
      state.ProposalStatusDetails = action.payload;
      state.loading = false;
    },
    [ProposalStatus.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },

    [createVendorTemplateList.pending.type]: (state) => {
      state.loading = true;
    },
    [createVendorTemplateList.fulfilled.type]: (
      state,
      action: PayloadAction<LegalServiceStatusModal | null>
    ) => {
      state.templateResponseMessage = action.payload;
      state.loading = false;
    },
    [createVendorTemplateList.rejected.type]: (
      state,
      action: PayloadAction<ErrorInformation | null>
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const {
  updateOrgFileCommentForm,
  updateOrgFileForm,
  updateOrgPricingForm,
  updateOrgJurisdictionForm,
  updateLearningForm,
  updateOrgIndustriesForm,
  updateOrgPracticesForm,
  handleResetLegalServiceProposalDetail,
  setProposalDataByTemplate,
  proposalDetailIdsStore,
  proposalDetailIdsRemove,
  handleResetMasterTemplate,
} = legalServiceSlice.actions;

export default legalServiceSlice;
